import { useEffect } from "react";

const INTERVAL_MS = 2500;
// ~90s: process-manifests, which writes what these polls wait on, can take
// most of a minute after the write that queued it.
const MAX_ATTEMPTS = 36;

/**
 * Refetch on an interval while `active`, giving up after ~90s.
 *
 * For drawer state that a background job settles after the user's own write
 * has already returned. Stops as soon as `active` turns false; a new
 * `restartKey` starts a fresh run, so a second upload gets its own window.
 */
export function useBoundedRefetch(active: boolean, refetch: () => void, restartKey = 0) {
  useEffect(() => {
    if (!active) return;
    let attempts = 0;
    const intervalId = setInterval(() => {
      attempts += 1;
      refetch();
      if (attempts >= MAX_ATTEMPTS) clearInterval(intervalId);
    }, INTERVAL_MS);
    return () => clearInterval(intervalId);
  }, [active, refetch, restartKey]);
}
